import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiResponse } from '../_model/ApiResponse';
import { EmployeeAddRequest } from '../_model/request/EmployeeAddRequest';
import { EmployeeUpdateRequest } from '../_model/request/EmployeeUpdateRequest';
import { Employee } from '../_model/Employee';
import { EmployeeIdariRequest } from '../_model/request/EmployeeIdariRequest';
import { EmployeeSearchRequest } from '../_model/request/EmployeeSearchRequest';
import { EmployeeReportRequest } from '../_model/request/EmployeeReportRequest';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService extends BaseService {




  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }

  getEmployee(): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/employees');
  }
  getEmployeeList(departmentId: number): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/overtimes/employees?departmentId=' + departmentId);
  }

  getEmployeeById(employeeId): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/employees/' + employeeId);
  }
  getEmployeeByActive(employeeSearchRequest: EmployeeSearchRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/employees/actives', employeeSearchRequest);
  }
  getEmployeeReport(employeeReportRequest: EmployeeReportRequest): Observable<ApiResponse> {
    return this.post<ApiResponse>('/api/v1/employees/actives/report', employeeReportRequest);
  }
  addEmployee(employeeAddRequest: EmployeeAddRequest) {
    return this.post<ApiResponse>('/api/v1/employees', employeeAddRequest);
  }
  updateEmployee(employeeRequest: EmployeeUpdateRequest) {
    return this.put<ApiResponse>('/api/v1/employees', employeeRequest);
  }
  getManager(id): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/employees/' + id + '/managers');
  }
  deleteEmployee(employee: Employee) {
    return this.delete<ApiResponse>('/api/v1/employees/' + employee.id);
  }
  getEmployeeIdari(id): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/employees/getFreePeriods/' + id);
  }
  addEmployeeIdari(employeeIdari: EmployeeIdariRequest) {
    return this.post<ApiResponse>('/api/v1/employees/saveFreePeriod', employeeIdari);
  }
  deleteEmployeeIdari(id) {
    return this.delete<ApiResponse>('/api/v1/employees/deleteFreePeriod/' + id);
  }
  getTopManagers(): Observable<ApiResponse> {
    return this.get<ApiResponse>('/api/v1/employees/managers/top');
  }
}
